module.exports = __webpack_public_path__ + "static/media/roadtrain.6e04a809.gif";